import React, {useState} from "react";
import img from "./assets/img.png";
const Vison = () => {
  return (
    <div className="mt-[80px] md:mt-[208px]">
      <div className="container">
        <div className="max-w-[1143px] mx-auto">
          <div className="flex md:flex-row flex-col gap-[64px]  items-center">
            <div className="flex justify-center">
              <img src={img} alt="" />
            </div>
            <div className="max-w-[679px] w-full mt-[7px]">
              <h2 className="text-res-lg font-semibold mb-[9px]">Our Vision</h2>
              <p className="mb-[20px] font-semibold text-res-xs leading-[30px]">
                At R34P DAO, our mission is to revolutionize decentralized
                finance and empower individuals worldwide. We provide a
                transparent and inclusive platform that enables users to take
                control of their financial future. Through our NFTs, community
                initiatives, and support for groundbreaking DeFi projects, we
                bridge the gap between traditional finance and the decentralized
                world, making it accessible and user-friendly for everyone. We
                are committed to maintaining the highest standards of
                transparency, security, and integrity, creating a safe and
                trustworthy environment for our community to engage in
                decentralized finance. Together, we are driving the adoption of
                decentralized finance, fostering financial empowerment, and
                contributing to the growth and development of a decentralized
                ecosystem.
              </p>
              <button className="border w-[173px] h-10 rounded-[20px] font-bold border-solid border-white">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vison;
